import type { IFreezeFanExcpt } from '@module/apis/client-side/chat/type';
import type { CentrifugeMessage } from '../messageTypes';

export interface FreezeOnMessage {
  data: {
    type: 'FreezeOn';
    message: {
      freezeManagerExcpt?: 'Y' | 'N'; // 매니저 얼리기 예외여부
      freezeFanExcpt?: IFreezeFanExcpt; // 팬얼리기 예외여부
      name: string;
      messageType?: 'now' | 'past';
    };
    created_at?: number;
  };
  offset: number;
}

export const isFreezeOnMessage = (item: CentrifugeMessage): item is FreezeOnMessage => {
  return 'data' in item && item.data.type === 'FreezeOn';
};

export interface FreezeOffMessage {
  data: {
    type: 'FreezeOff';
    message: {
      name: string;
    };
    created_at?: number;
  };
  offset: number;
}

export const isFreezeOffMessage = (item: CentrifugeMessage): item is FreezeOffMessage => {
  return 'data' in item && item.data.type === 'FreezeOff';
};
export interface FrozenMessage {
  data: {
    type: 'Frozen';
    message: string;
  };
  offset: number;
}

export const isFrozenMessage = (item: CentrifugeMessage): item is FrozenMessage => {
  return 'data' in item && item.data.type === 'Frozen';
};
